import React from 'react';
import { motion } from 'framer-motion';
import { Github, Linkedin, Mail } from 'lucide-react';
import { useTheme } from '../ThemeContext';

export default function Footer() {
  const { isCyberpunk } = useTheme();

  return (
    <footer className={`relative py-12 px-6 border-t transition-colors duration-500 ${
      isCyberpunk
        ? 'border-cyber-magenta/10 bg-cyber-black'
        : 'border-gray-200 bg-white'
    }`}>
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-center gap-6 mb-8">
          {[
            { icon: Github, href: 'https://github.com/sabu6516' },
            { icon: Linkedin, href: 'https://linkedin.com/in/samuel-buckler' },
            { icon: Mail, href: 'mailto:sabu6516@colorado.edu' },
          ].map(({ icon: Icon, href }, i) => (
            <motion.a
              key={i}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ y: -3 }}
              className={`transition-colors ${
                isCyberpunk
                  ? 'text-cyber-dim/40 hover:text-cyber-magenta'
                  : 'text-gray-400 hover:text-indigo-600'
              }`}
            >
              <Icon size={18} />
            </motion.a>
          ))}
        </div>

        <div className="text-center">
          <p className={`font-mono text-xs tracking-wider transition-colors duration-500 ${
            isCyberpunk ? 'text-cyber-dim/30' : 'text-gray-400'
          }`}>
            {isCyberpunk ? (
              <>
                <span className="text-cyber-magenta/30">&lt;</span>
                {' '}Designed & Built by Samuel Buckler{' '}
                <span className="text-cyber-magenta/30">/&gt;</span>
              </>
            ) : (
              'Designed & Built by Samuel Buckler'
            )}
          </p>
          <p className={`font-mono text-xs mt-2 transition-colors duration-500 ${
            isCyberpunk ? 'text-cyber-dim/20' : 'text-gray-300'
          }`}>
            &copy; {new Date().getFullYear()}{isCyberpunk ? ' | All systems operational' : ''}
          </p>
        </div>

        <div className={`mt-8 h-[1px] transition-colors duration-500 ${
          isCyberpunk
            ? 'bg-gradient-to-r from-transparent via-cyber-magenta/20 to-transparent'
            : 'bg-gradient-to-r from-transparent via-gray-200 to-transparent'
        }`} />
      </div>
    </footer>
  );
}
